Bingo.DashboardContract = {};
Bingo.DashboardContract.ParticipantSelect = {};
Bingo.DashboardContract.ParticipantSelect.init = ($dropdownSelector) => {
    $(document).on('click', `${$dropdownSelector} [data-participant]`, function (e) {
        e.preventDefault();
        const $dropdown = $(this).closest($dropdownSelector);
        const counter = $(this).attr('data-participant');

        $dropdown.find('[data-participant].-active').removeClass('-active');
        $dropdown.find(`[data-participant="${counter}"]`).addClass('-active');
        $dropdown.parent('.O-preview__content').find('[data-for-participant]').hide();
        $dropdown.parent('.O-preview__content').find(`[data-for-participant="${counter}"]`).show();
    });
};
